import { VaultService } from 'utils/storage';

interface ILocalStorageBalance {
	owner: string;
	balance: string;
}

export const getLocalStorageBalance = (): number => {
	const localStorage = new VaultService();

	const balanceObj = localStorage.getItem('balance') as ILocalStorageBalance;
	const userObj = localStorage.getItem('user') as Record<string, string>;

	if (balanceObj && balanceObj.owner === userObj?.id) return Number(balanceObj?.balance);

	return 0;
};

export const setLocalStorageBalance = (balance: number) => {
	const localStorage = new VaultService();
	const userId = (localStorage.getItem('user') as Record<string, string>)?.id;

	localStorage.setItem('balance', {
		balance: balance,
		owner: userId,
	});
};

export const deleteLocalStorageBalance = () => {
	const localStorage = new VaultService();

	localStorage.removeItem('balance');
};
